import React from 'react';
import { Link } from 'react-router-dom';

export function LoadingState({ label = 'Cargando…' }) {
  return (
    <div
      className="flex min-h-[50vh] flex-col items-center justify-center gap-3 text-muted"
      role="status"
      aria-live="polite"
    >
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-line border-t-primary" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function EmptyState({ title, description }) {
  return (
    <div className="py-16 text-center">
      <p className="font-display text-2xl font-semibold uppercase tracking-wide text-ink">
        {title}
      </p>
      {description && <p className="mt-2 text-muted">{description}</p>}
    </div>
  );
}

export function PageHeader({ title, lead, children }) {
  return (
    <header className="mb-10 text-center md:mb-14 md:text-left">
      <h1 className="page-title">{title}</h1>
      {lead && <p className="page-lead mx-auto md:mx-0">{lead}</p>}
      {children}
    </header>
  );
}

export function Section({ children, className = '', as: Tag = 'section' }) {
  return (
    <Tag className={`mx-auto w-full max-w-content ${className}`}>{children}</Tag>
  );
}

export function ContentCard({ children, className = '', as: Tag = 'article' }) {
  return (
    <Tag
      className={`rounded-lg border border-line bg-surface p-5 transition-transform duration-200 hover:-translate-y-0.5 md:p-6 ${className}`}
    >
      {children}
    </Tag>
  );
}

export function PrimaryLink({ to, children, className = '', ...props }) {
  return (
    <Link to={to} className={`btn-primary ${className}`} {...props}>
      {children}
    </Link>
  );
}

export function SecondaryLink({ to, children, className = '', ...props }) {
  return (
    <Link to={to} className={`btn-secondary ${className}`} {...props}>
      {children}
    </Link>
  );
}
